import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=600b9a42&"
import script from "./editPassword.vue?vue&type=script&lang=js&"
export * from "./editPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports